/**
 * Le groupe n'est-il composé QUE de moins de 12 ans (`babies` < 2 ans,
 * `infants` 2-11) ?
 *
 * Les 12-24 (`youngsters`) comptent comme accompagnants : à partir de 12 ans le
 * service UM devient facultatif chez les compagnies desservies, et un jeune seul
 * réserve son billet normalement puis signale son UM en spécificité après
 * paiement. Refuser sa recherche fermerait un cas que le site sait déjà traiter.
 */
export function isTravellingWithoutAdult(party) {
    const total = party.adults + party.babies + party.infants + party.seniors + party.youngsters;
    return total !== 0 && total === party.babies + party.infants;
}
/** Le texte affiché par le formulaire de recherche. Repris mot pour mot par le chatbot. */
export const NO_ADULT_MESSAGE = "Un bébé ou un enfant ne peuvent pas voyager seul, veuillez ajouter au moins un adulte ou appeler l'agence au 0491910698";
